"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Avatar = (props) => {
    const { children, src } = props;
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)),
        react_1.default.createElement("img", { alt: "avatar", src: src, width: 48, height: 48 }),
        children));
};
exports.default = withJourney_1.default('j-avatar', Avatar);
